import { Tab, Tabs } from "@nextui-org/react";
import { useState } from "react";
import HelpCenterTabs from "./helpCenter";
import GlossaryList from "./glossary/glossaryList";
import FAQList from "./faq/faqList";
import HeroBannerTabs from "./heroBanner";

const CMSModuleTabs = () => {
  const [selectedTab, setSelectedTab] = useState("faq");

  return (
    <div className="flex w-full flex-col justify-evenly">
      <Tabs
        variant="underlined"
        aria-label="User Module"
        className="w-full sm:justify-start"
        classNames={{
          tab: "px-6",
          tabList: ["overflow-x-auto text-[#FFFFFF80] sm:pl-8 max-sm:w-full"],
          cursor: "user-module-selected",
          tabContent:
            "text-base font-bold group-data-[selected=true]:text-[#FFFFFF]",
        }}
        selectedKey={selectedTab}
        onSelectionChange={(key) => setSelectedTab(key as string)}
      >
        <Tab key="faq" title="FAQ">
          <FAQList />
        </Tab>

        <Tab key="glossary" title="Glossary">
          <GlossaryList />
        </Tab>

        <Tab key="helpCenter" title="Help Center">
          <HelpCenterTabs />
        </Tab>

        <Tab key="heroBanner" title="Hero Banner">
          <HeroBannerTabs />
        </Tab>

        {/* <Tab key="blog" title="Blog"> */}
        {/*   <BlogsList /> */}
        {/* </Tab> */}
      </Tabs>
    </div>
  );
};

export default CMSModuleTabs;
